import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { AiOutlineDownload } from 'react-icons/ai';
import { Button, Flex, Text } from 'core/components';
import ToolResultCard from '../components/ToolResultCard';

@inject('$journeys')
@observer
class ExportPdfToolResult extends Component {
  handleDownload = () => {
    const { tool, $journeys } = this.props;
    const sessionId = tool?.raw_result?.sessionId;
    if (sessionId) {
      $journeys.exportPdf(sessionId);
    }
  };

  render() {
    const { tool, onCloseToolResult, isInlineMode = false } = this.props;
    const sessionId = tool?.raw_result?.sessionId;

    return (
      <ToolResultCard
        tool={tool}
        onCloseToolResult={onCloseToolResult}
        className="tool-result-export-pdf"
        title={tool.title || 'Export Conversation as PDF'}
        isInlineMode={isInlineMode}
      >
        <Flex flexDirection="column" gap={2} p={2}>
          <Text>Your conversation is ready to download as a PDF.</Text>
          <Flex>
            <Button
              intent="primary"
              icon={AiOutlineDownload}
              text="Download PDF"
              onClick={this.handleDownload}
              disabled={!sessionId}
              tracker="ai-advisor-tool-export-pdf-download"
            />
          </Flex>
        </Flex>
      </ToolResultCard>
    );
  }
}

export default ExportPdfToolResult;
